export default "__VITE_ASSET__HDx12pf2__"